import React from "react";
import { User } from "oidc-client";
import { CallbackComponent, loadUser } from "redux-oidc";
import { push } from "connected-react-router";
import { useDispatch } from "react-redux";
import { userManager } from "../../../core/services/user.manager.service";
import store from "../../store";
import { TypeSollicitation } from "../../../core/apis/monsisra/generated";

/**
 * Composant qui traite les jetons renvoyés par le Portail d'authentification, initialise la session sur Redux
 * et redirige vers les pages authentifiées.
 */

type AuthCallbackProps = {
	type: TypeSollicitation;
	idDocument?: string;
};
const AuthCallback = ({ type, idDocument }: AuthCallbackProps) => {
	const dispatch = useDispatch();

	return (
		<CallbackComponent
			userManager={userManager}
			successCallback={async (user: User) => {
				console.log("Auth success");
				//Appel à un helper qui propage au "store" les actions pour charger l'utilisateur.
				await loadUser(store, userManager);
				dispatch(push(user.state || '/expert'))
			}}
			errorCallback={(error) => {
				console.log("Auth error");
				console.error(error);
				dispatch(push("/auth-error"));
			}}
		>
			{<div>...</div>}
		</CallbackComponent>
	);
};

export default AuthCallback;
